import React from "react";

function ErrorPage() {
  return (
    <div class="site-main">
      <section class="error-404 ttm-bgcolor-grey clearfix">
        <div class="container">
          <div class="ttm-big-icon ttm-textcolor-skincolor">
            <i class="fa fa-thumbs-o-down"></i>
          </div>
          <header class="page-header">
            <h1 class="page-title">404 ERROR</h1>
          </header>
          <div class="page-content">
            <p>
              The page you are looking for doesn't exist, please verify the url
            </p>
          </div>
          <a
            class="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-border ttm-btn-color-dark"
            href="/"
          >
            Back To Home
          </a>
        </div>
      </section>
    </div>
  );
}

export default ErrorPage;
